import { jsx as _jsx } from "react/jsx-runtime";
import { Form } from 'antd';
import SpeakerAvatar from './SpeakerAvatar';
const SpeakerAvatarField = ({ name, size, editable, className, disabled = false, }) => {
    return (_jsx(Form.Item, { name: name, className: className, children: _jsx(SpeakerAvatar, { size: size, editable: editable, disabled: disabled }) }));
};
export default SpeakerAvatarField;
